export default __webpack_public_path__ + "static/media/global-settings.09a0202d.svg";